var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9073 4.14387C12.3852 1.38727 10.0843 0 7 0C3.91404 0 1.61482 1.38727 0.0927157 4.14525C0.0316634 4.25639 0 4.37778 0 4.50069C0 4.6236 0.0316634 4.74499 0.0927157 4.85613C1.61482 7.61273 3.91564 9 7 9C10.086 9 12.3852 7.61273 13.9073 4.85475C14.0309 4.63113 14.0309 4.37163 13.9073 4.14387ZM7 8.00613C4.41017 8.00613 2.51396 6.87699 1.17649 4.5C2.51396 2.12301 4.41017 0.993865 7 0.993865C9.58982 0.993865 11.486 2.12301 12.8235 4.5C11.4876 6.87699 9.59143 8.00613 7 8.00613ZM6.93577 2.07055C5.37513 2.07055 4.10992 3.15828 4.10992 4.5C4.10992 5.84172 5.37513 6.92945 6.93577 6.92945C8.49641 6.92945 9.76162 5.84172 9.76162 4.5C9.76162 3.15828 8.49641 2.07055 6.93577 2.07055ZM6.93577 6.04601C5.94191 6.04601 5.1375 5.35445 5.1375 4.5C5.1375 3.64555 5.94191 2.95399 6.93577 2.95399C7.92964 2.95399 8.73404 3.64555 8.73404 4.5C8.73404 5.35445 7.92964 6.04601 6.93577 6.04601Z",
    fill: "#2A5578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f99324813f78d5364e6f5aa8c5566f11.svg";
export { ForwardRef as ReactComponent };